import React from 'react';
import PropTypes from 'prop-types';

import { Button, Stack } from '@metarouter-private/mr-mui';

export default function DeployProgressActions({ isComplete, onClose, onBackToPipelines, onReload }) {
  return (
    <Stack direction="row" spacing={1}>
      <Button
        onClick={onClose}
        disabled={!isComplete}
        color="secondary"
        variant="outlined"
        data-test-id="deployProgressCloseButton"
      >
        Close
      </Button>

      <Button
        onClick={onBackToPipelines}
        disabled={!isComplete}
        color="secondary"
        variant="outlined"
        data-test-id="deployProgressBackButton"
      >
        Back to Pipelines
      </Button>

      <Button
        onClick={onReload}
        disabled={!isComplete}
        color="primary"
        variant="contained"
        data-test-id="deployProgressReloadButton"
      >
        Reload
      </Button>
    </Stack>
  );
}

DeployProgressActions.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onBackToPipelines: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
};
